module.exports = __webpack_public_path__ + "img/icon_left_6.8cdcf111.png";